import React from 'react';
import {Pagination} from "antd";
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import "./TasksTableFooter.css";

const TasksTableFooter = ({contentUpdater, pagination: {currentPage, currentPageSize, totalElements}}) => {
  return (
    <footer className="table-wrapper__footer">
      <Pagination
        className="pagination"
        current={currentPage}
        defaultCurrent={1}
        onChange={contentUpdater}
        showSizeChanger
        onShowSizeChange={contentUpdater}
        pageSizeOptions={["10", "25", "50", "100"]}
        defaultPageSize={10}
        pageSize={currentPageSize}
        total={totalElements}
      />
    </footer>
  );
};

TasksTableFooter.propTypes = {
  contentUpdater: PropTypes.func,
  totalElements: PropTypes.number,
};

const mapStateToProps = state => ({
  pagination: state.fetchInterventions.pagination,
});

export default connect(mapStateToProps)(TasksTableFooter);
